import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaPiggyBank, FaBriefcase, FaHome, FaLandmark } from 'react-icons/fa';
import './OurServices.css';

const OurServices = () => {
    const { t } = useTranslation();

    const services = [
        {
            icon: <FaPiggyBank />,
            titleKey: 'ourServices.savings.title',
            descKey: 'ourServices.savings.description',
            path: '/deposits#setting'
        },
        {
            icon: <FaLandmark />,
            titleKey: 'ourServices.fixedDeposit.title',
            descKey: 'ourServices.fixedDeposit.description',
            path: '/deposits#fixed'
        },
        {
            icon: <FaBriefcase />,
            titleKey: 'ourServices.businessLoan.title',
            descKey: 'ourServices.businessLoan.description',
            path: '/loans#cash-credit-loan'
        },
        {
            icon: <FaHome />,
            titleKey: 'ourServices.homeLoan.title',
            descKey: 'ourServices.homeLoan.description',
            path: '/loans#property-loan'
        },
        {
            icon: <FaShieldAlt />,
            titleKey: 'ourServices.insurance.title',
            descKey: 'ourServices.insurance.description',
            path: '/financial-info#insurance'
        }
    ];

    return (
        <section className="py-20 bg-gray-50 relative overflow-hidden">

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">{t('ourServices.badge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
                        {t('ourServices.heading')}
                    </h2>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
                        {t('ourServices.subheading')}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {services.map((service, index) => (
                        <Link
                            key={index}
                            to={service.path}
                            className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 hover:border-primary/30 hover:shadow-xl transition-all duration-300 group flex flex-col items-center text-center h-full relative overflow-hidden"
                        >
                            <div className="absolute top-0 left-0 w-full h-1 bg-gray-100 group-hover:bg-primary transition-colors duration-300"></div>

                            <div
                                className="w-14 h-14 rounded-full mb-6 flex items-center justify-center text-2xl text-primary bg-blue-50 group-hover:bg-primary group-hover:text-white transition-all duration-300"
                            >
                                {service.icon}
                            </div>
                            <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300">
                                {t(service.titleKey)}
                            </h3>
                            <p className="text-gray-500 text-sm leading-relaxed flex-grow">
                                {t(service.descKey)}
                            </p>

                            <div className="mt-6">
                                <span className="text-primary text-xs font-bold uppercase tracking-wider group-hover:underline decoration-secondary underline-offset-4">{t('ourServices.learnMore')}</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurServices;
